import React from 'react';
import t from 'babel-plugin-yate/macro';

import {getDocumentURL} from '../lib/misc';
import {FileUploadInput} from './FileUploadInput';
import ValidationError from './Form/ValidationError';

export const DocumentsUploadBox = ({
  acceptFileTypes = 'image/*,.pdf',
  description = '',
  documents = [],
  uploadInputLabel = '',
  isFileUploaded = false,
  isFileMissing = false,
  isLoading = false,
  isLabelUploadInputDisabled,
  isTemplateDownloadLinkDisabled,
  download = true,
  templateURL = '',
  showTemplateDownloadLink,
  onUnsavedApplication = () => {},
  onUpload,
  errorMessage = '',
  isReadOnly,
  showPreview = false,
  showDownloadLink = true,
  isSingleUpload = true,
  warningUnsavedApplication = '',
}) => (
  <div className="w-full">
    {showTemplateDownloadLink && templateURL && (
      <div className="p-3 border-b">
        <a
          href={isTemplateDownloadLinkDisabled ? '/' : templateURL}
          target="_blank"
          download={download}
          rel="noopener noreferrer">
          [{t`Download agreement`}]
        </a>
      </div>
    )}

    {isLoading ? (
      <div className="flex items-center justify-center relative min-h-200 text-20">
        <div className="spinner" />
      </div>
    ) : (
      <>
        {!isReadOnly && (
          <div className="pt-8 p-4">
            {description && <p className="text-12 mb-4">{description}</p>}

            <FileUploadInput
              accept={acceptFileTypes}
              isFileUploaded={isFileUploaded}
              isFileMissing={isFileMissing}
              isLabelUploadInputDisabled={isLabelUploadInputDisabled}
              label={uploadInputLabel}
              onDone={onUpload}
              triggerWarning={onUnsavedApplication}
            />

            {errorMessage && <ValidationError value={errorMessage} />}

            {warningUnsavedApplication && (
              <ValidationError value={warningUnsavedApplication} />
            )}

            {isSingleUpload && !!documents.length && (
              <p className="text-12">
                {t`Upload another document if you want to replace the existing one.`}
              </p>
            )}
          </div>
        )}

        {!!documents.length &&
          documents.map(
            (
              {file_name = '', content = '', metadata = {}, id = undefined},
              index,
            ) => (
              <div key={index}>
                {showPreview &&
                  isSingleUpload &&
                  ['image/png', 'image/jpeg'].includes(
                    metadata['mime_content_type'],
                  ) && (
                    <div className="border-t text-center">
                      <img
                        className={!showDownloadLink ? 'rounded-b' : ''}
                        src={content || getDocumentURL(id)}
                        alt={file_name}
                      />
                    </div>
                  )}

                {showDownloadLink && (
                  <div className="border-t p-4">
                    <a
                      href={content || getDocumentURL(id)}
                      target="_blank"
                      rel="noopener noreferrer"
                      download={file_name}
                      className="text-grey-darker-1">
                      {file_name}
                    </a>
                  </div>
                )}
              </div>
            ),
          )}
      </>
    )}
  </div>
);
